import React from 'react';
import {
  Box,
  Container,
  Grid,
  Typography,
  Link,
  Divider,
  IconButton,
  TextField,
  InputAdornment,
} from '@mui/material';
import {
  Facebook,
  Twitter,
  Instagram,
  LinkedIn,
  YouTube,
  Send,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const Footer = () => {
  const navigate = useNavigate();

  const menuItems = [
    "Personal",
    "Homeopathy", 
    "Immunity Boosters",
    "Ayurveda",
    "Fitness",
    "Healthcare Devices",
    "Oral Care",
    "Treatments",
    "Sexual Wellness",
    "Surgicals",
  ];

  const socialLinks = [
    { name: 'Facebook', href: 'https://facebook.com' },
    { name: 'Twitter', href: 'https://twitter.com' },
    { name: 'LinkedIn', href: 'https://linkedin.com' },
    { name: 'Youtube', href: 'https://youtube.com' },
    { name: 'Instagram', href: 'https://instagram.com' },
    { name: 'Refer & Earn', href: '#!' },
  ];

  const policies = [
    { label: 'Terms and Conditions', path: '/terms-and-conditions' },
    { label: 'Privacy Policy', path: '/privacy-policy' },
    { label: 'Fees and Payments Policy', path: '/fees-and-payments-policy' },
    { label: 'Shipping and Delivery Policy', path: '/shipping-and-delivery-policy' },
    { label: 'Return, Refund and Cancellation Policy', path: '/return-refund-and-cancellation-policy' },
    { label: 'Editorial Policy', path: '/editorial-policy' },
  ];

  const handleLinkClick = (path) => {
    navigate(path);
  };

  const redirectTo = (item) => {
    const url = `/otcproducts/?category=${encodeURIComponent(item)}`;
    navigate(url);
  };

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: 'white',
        color: 'primary.main',
        mt: 'auto',
        py: 6,
      }}
    >
      <Container maxWidth="lg">
        {/* Company Header */}
        <Grid container spacing={4}>
          <Grid item xs={12} sx={{ textAlign: 'center' }}>
            <Typography variant="h4" component="h2" gutterBottom>
              Pharma Man
            </Typography>
            <Divider sx={{ my: 2 }} />
            <Typography variant="body1" paragraph>
              pharmaman.com is one of India's most trusted pharmacies,
              dispensing quality medicines at reasonable prices to all customers
              – PAN India.
            </Typography>
            <Divider sx={{ my: 2 }} />
          </Grid>
        </Grid>

        {/* Main Footer Content */}
        <Grid container spacing={4}>
          {/* Company Section */}
          <Grid item xs={12} md={3}>
            <Typography variant="h6" gutterBottom>
              COMPANY
            </Typography>
            <Box component="ul" sx={{ listStyle: 'none', p: 0 }}>
              <Box component="li" sx={{ mb: 1 }}>
                <Link
                  component="button"
                  variant="body2"
                  color="primary"
                  onClick={() => handleLinkClick('/about-us')}
                  sx={{
                    textAlign: 'left',
                    textDecoration: 'none',
                    '&:hover': { textDecoration: 'underline' },
                  }}
                >
                  About Pharma Man
                </Link>
              </Box>
              <Box component="li" sx={{ mb: 1 }}>
                <Link
                  component="button"
                  variant="body2"
                  color="primary"
                  onClick={() => handleLinkClick('/testimonials')}
                  sx={{
                    textAlign: 'left',
                    textDecoration: 'none',
                    '&:hover': { textDecoration: 'underline' },
                  }}
                >
                  Testimonials
                </Link>
              </Box>
              <Box component="li" sx={{ mb: 1 }}>
                <Link
                  component="button"
                  variant="body2"
                  color="primary"
                  onClick={() => handleLinkClick('/contact-us')}
                  sx={{
                    textAlign: 'left',
                    textDecoration: 'none',
                    '&:hover': { textDecoration: 'underline' },
                  }}
                >
                  Contact
                </Link>
              </Box>
            </Box>
          </Grid>

          {/* Policies Section */}
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom>
              OUR POLICIES
            </Typography>
            <Box component="ul" sx={{ listStyle: 'none', p: 0 }}>
              {policies.map((policy) => (
                <Box component="li" key={policy.path} sx={{ mb: 1 }}>
                  <Link
                    component="button"
                    variant="body2"
                    color="primary"
                    onClick={() => handleLinkClick(policy.path)}
                    sx={{
                      textAlign: 'left',
                      textDecoration: 'none',
                      '&:hover': { textDecoration: 'underline' },
                    }}
                  >
                    {policy.label}
                  </Link>
                </Box>
              ))}
            </Box>
          </Grid>

          {/* Popular Categories Section */}
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom>
              POPULAR CATEGORIES
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Box component="ul" sx={{ listStyle: 'none', p: 0 }}>
                  {menuItems.map((item, index) => (
                    index % 2 === 0 && (
                      <Box component="li" key={index} sx={{ mb: 1 }}>
                        <Link
                          component="button"
                          variant="body2"
                          color="primary"
                          onClick={() => redirectTo(item)}
                          sx={{
                            textAlign: 'left',
                            textDecoration: 'none',
                            '&:hover': { textDecoration: 'underline' },
                          }}
                        >
                          {item}
                        </Link>
                      </Box>
                    )
                  ))}
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Box component="ul" sx={{ listStyle: 'none', p: 0 }}>
                  {menuItems.map((item, index) => (
                    index % 2 !== 0 && (
                      <Box component="li" key={index} sx={{ mb: 1 }}>
                        <Link
                          component="button"
                          variant="body2"
                          color="primary"
                          onClick={() => redirectTo(item)}
                          sx={{
                            textAlign: 'left',
                            textDecoration: 'none',
                            '&:hover': { textDecoration: 'underline' },
                          }}
                        >
                          {item}
                        </Link>
                      </Box>
                    )
                  ))}
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {/* Newsletter Section */}
        <Grid container spacing={4} sx={{ mt: 2 }}>
          <Grid item xs={12} sx={{ textAlign: 'center' }}>
            <Typography variant="h6" gutterBottom>
              Subscribe To Our Newsletter
            </Typography>
            <TextField
              placeholder="Enter your email address"
              variant="outlined"
              size="small"
              sx={{ maxWidth: 400 }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton color="primary">
                      <Send />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
        </Grid>

        {/* Social Media Section */}
        <Box sx={{ textAlign: 'center', mt: 3 }}>
          <Typography variant="h6" gutterBottom>
            SOCIAL
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, flexWrap: 'wrap' }}>
            {socialLinks.map((social) => (
              <Link
                key={social.name}
                href={social.href}
                target="_blank"
                rel="noopener"
                color="primary"
                sx={{ textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
              >
                {social.name}
              </Link>
            ))}
          </Box>
        </Box>

        <Divider sx={{ my: 3 }} />

        {/* Payment Partners Section */}
        <Box sx={{ textAlign: 'center' }}>
          <Typography variant="h6" gutterBottom>
            OUR PAYMENT PARTNERS
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, flexWrap: 'wrap' }}>
            <Typography variant="body2" color="text.secondary">
              Google Pay | PhonePe | Paytm | Simpl | RuPay | Visa | Mastercard
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
